import React from 'react'
import type { HeaderRowConfig } from '@ztechapps/webui.data-tools'
import { CheckboxHeaderCell } from '@ztechapps/webui.data-tools'
import { MenuHeaderCell } from '@ztechapps/webui.data-tools'
import { useSerialNumberSelectListContext } from './Context'

export const ListHeader = (props: HeaderRowConfig) => {
  const { listWithSelection, disabled } = useSerialNumberSelectListContext()
  const { toggleSelectAll, hasSelectedAll } = listWithSelection
  return (
    <>
      <MenuHeaderCell />
      <CheckboxHeaderCell onChange={toggleSelectAll} checked={hasSelectedAll} disabled={disabled} />

      {props._renderDataHeaderCell()}
    </>
  )
}
